import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './assets/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import './assets/css/style.css'
import './assets/css/responsive.css'
import './assets/css/edit.css'
import Home from './pages/home/home';
import TagList from "../src/pages/home/list-show-all";
import Login from './admin/login';
import AdminList from './admin/admin-list';
import UserList from './admin/user-list';
import VideoList from './admin/video-list';
import VideoRequest from './admin/video-requests';
import TagDirectory from './admin/tag-directory';
import { useSelector } from 'react-redux';
//import SharePage from "../src/pages/home/share"
import SharePage from "../src/pages/home/ListVideo"
import ApproverList from './admin/approver-list';
import React, { useEffect, useState } from "react";
 import { onAuthStateChanged, signOut } from "firebase/auth";
 import { auth } from "../src/admin/firebase";
// import Login from "./Login";
function App() {
  const { isAuthenticated } = useSelector((state) => state.authentication)
  const { userData } = useSelector((state) => state.masterData)
  const [user, setUser] = useState(null);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsubscribe();
  }, []);
  return (

    <Router>
      <Routes>
        <Route path='/' element={<Home />}></Route>
        <Route path='/tag-search' element={<TagList />}></Route>
        <Route path='/login' element={<Login />}></Route>
        <Route path='/share/:id' element={<SharePage />}></Route>
        {(isAuthenticated && userData.roleDisplayName !== "User" && userData.roleDisplayName !== "APPROVER") &&
          <Route path='/tags-directory' element={<TagDirectory />}></Route>
        }
        {(isAuthenticated && userData.roleDisplayName !== "User") &&
          <Route>
            <Route path='/video-list' element={<VideoList />}></Route>
          </Route>
        }
        {(isAuthenticated && userData.roleDisplayName === "Super_admin") &&
          <Route>
            <Route path='/admin-list' element={<AdminList />}></Route>
            <Route path='/approver-list' element={<ApproverList />}></Route>
          </Route>
        }
        {(isAuthenticated && (userData.roleDisplayName === "Super_admin" || userData.roleDisplayName === "APPROVER")) &&
          <Route>
            <Route path='/user-list' element={<UserList />}></Route>
            <Route path='/video-request' element={<VideoRequest />}></Route>
          </Route>
        }
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
